export const localUrls = {
    login: "/login",
    logout: "/logout",
    account: "/account",
    accountCreate: "/",
};
